module.exports = __webpack_public_path__ + "media/customizations/serranoeldorado/logo-9b681b444185e1dfd925651e0005f1e9.png";